module.exports = __webpack_public_path__ + "static/media/example-3.dcc61ced.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyCentral/example-3.jpg
// module id = 284
// module chunks = 0